<template>
  <div class="">
    <ul class="tp-allshow-list" v-if="filteredItems">
      <show-element
          v-for="item in filteredItems.items" :key="item.slug"
          :name="item.name"
          :image="item.image"
          :lang="$store.state.lang"
          :projectSlug="item.projectSlug"
          :channelSlug="item.channelSlug"
          :typeSlug="typeSlug"
          :slug="item.slug"
          :seoKeywords="item.seoKeywords"
          :seoDescription="item.seoDescription"
          :seoTitle="item.seoTitle"
      ></show-element>
    </ul>
    <!--  SLDS_Teleportal_Footer  -->
    <!--    <div class="g-tag-wrap">-->
    <!--      <div id='div-gpt-ad-1629990708709-0' :bind="foot1"></div>-->
    <!--    </div>-->
    <!--  SLDS_Teleportal_Footer end -->
    <foot v-if="this.filteredItems"></foot>
  </div>
</template>

<script>
import ShowElement from "@/components/parts/showElement";
import axios from "axios";
import config from "../../public/js/config";
import Foot from "@/components/footer";

export default {
  components: {
    Foot,
    ShowElement,
  },
  name: "sortedShow",
  data() {
    return {
      filtered: this.$route.params.filtered,
      itemlist: [],
      filteredItems: null,
      fullPath: this.$route.fullPath,
      slug: this.$route.params.slug,
      typeSlug: this.$router.currentRoute.matched[0].path.substring(14),
      channelSlug: this.$route.params.channelSlug,
      seoTitle: this.$route.params.seoTitle,
      seoDescription: this.$route.params.seoDescription,
      seoKeywords: this.$route.params.seoKeywords,
      projectSlug: null
    }
  },
  metaInfo() {
    if (this.filteredItems) {
      if (this.channelSlug === 'stb') {
        return {
          title: this.filteredItems.channels[0].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[0].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[0].seoKeywords
            }
          ]
        }
      }
      if (this.channelSlug === 'novyy-kanal') {
        return {
          title: this.filteredItems.channels[1].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[1].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[1].seoKeywords
            }
          ]
        }
      } else {
        return {
          title: this.filteredItems.channels[2].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[2].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[2].seoKeywords
            }
          ]
        }
      }
    }
  },
  beforeCreate() {
    // window.googletag.cmd.push(() => {
    //   window.googletag.destroySlots();
    // });
    // console.log('this.$router.currentRoute', this.$router.currentRoute)
    // this.$store.dispatch('show');
    // this.$store.dispatch('serials');
    // this.$store.dispatch('films');
  },
  created() {
    // console.log(this.$route.params)
    // console.log(this.$router.currentRoute)
  },
  mounted() {
    // this.foot1();
    axios.get(config.VUE_APP_API_BASE_URL + this.fullPath, {})
        .then(response => {
          this.filteredItems = response.data
          this.$store.state.allshow = response.data
          this.$store.state.series = response.data
        })
        .catch(err => {
          if (err) {
            console.log(err)
            // window.location.href = '/' + this.$store.state.lang + '/404'
          }
        })
  },
  methods: {
    // foot1() {
    //   window.googletag.cmd.push(function () {
    //     if (window.innerWidth > 970) {
    //       window.googletag.defineSlot('/58302844/SLDS_Teleportal_Footer', [[728, 90], [970, 90]], 'div-gpt-ad-1629990708709-0').addService(window.googletag.pubads());
    //     }
    //     else {
    //       window.googletag.defineSlot('/58302844/SLDS_Teleportal_Footer', [320, 50], 'div-gpt-ad-1629990708709-0').addService(window.googletag.pubads());
    //     }
    //     window.googletag.display('div-gpt-ad-1629990708709-0');
    //   });
    // }
  },
  watch: {},

  computed: {},
}
</script>

<style scoped>

</style>
